import { GrapevinePostApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevinePostApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new GrapevinePostApi(configuration), [configuration]);
};
